import axios from "axios.js";

// Defines all states values
export const GET_SEARCH_LIST = "GET_SEARCH_LIST";
export const GET_RECENT_SEARCH_LIST = "GET_RECENT_SEARCH_LIST";
export const UPDATE_RECENT_SEARCH = "UPDATE_RECENT_SEARCH";
export const GET_DISTRICT_LIST = "GET_DISTRICT_LIST";
export const GET_BLOCKBYDISTRICT_LIST = "GET_BLOCKBYDISTRICT_LIST";
export const GET_CLUSTERBYBLOCK_LIST = "GET_CLUSTERBYBLOCK_LIST";

export const getSearchList = (serachKeyword) => (dispatch) => { // get search list api call
  axios.get(`/search/filter/keyword/${serachKeyword}`).then((res) => {
    dispatch({
      type: GET_SEARCH_LIST,
      payload: res.data,
    });
  });
};

export const getRecentSearchList = () => (dispatch) => { // get recent search list api call
  axios.get(`/recentsearch`).then((res) => {
    dispatch({
      type: GET_RECENT_SEARCH_LIST,
      payload: res.data,
    });
  });
};

export const clearRecentSearch = () => (dispatch) => { // clear recent search api call
  axios.delete(`/recentsearch/deleteall`).then((res) => {
    dispatch({
      type: GET_RECENT_SEARCH_LIST,
      payload: res.data,
    });
  });
};

export const updateRecentSearch = (item) => (dispatch) => { // update recent search data
  axios.post(`/recentsearch/create`, { value: item._source }).then((res) => {
    dispatch(getRecentSearchList());
  });
};

export const getdistrictList = () => (dispatch) => { // get district list on global search api
  axios.get(`/search/filter/district`).then((res) => {
    dispatch({
      type: GET_DISTRICT_LIST,
      payload: res.data,
    });
  });
};

export const getblockByDistrictList = (id) => (dispatch) => { // gt block list by district on global search api call
  axios.get(`search/filter/block/${id}`).then((res) => {
    dispatch({
      type: GET_BLOCKBYDISTRICT_LIST,
      payload: res.data,
    });
  });
};

export const getclusterbyblockList = (id) => (dispatch) => { // get cluster list by block on global search api call 
  axios.get(`search/filter/cluster/${id}`).then((res) => {
    dispatch({
      type: GET_CLUSTERBYBLOCK_LIST,
      payload: res.data,
    });
  });
};